function memoizeCapped(func: Function) {
    return func;
}

export default memoizeCapped;